import { edmCampaign } from '@bingads-webui/edm-campaign';
import { mockedTags } from './mock-data';

export const getTags = (cid, aid) => {
  if (cid && aid) {
    return edmCampaign
      .Customers.$withKey(cid)
      .Accounts.$withKey(aid)
      .Tags
      .get({
        top: 200,
        select: ['Id', 'Name', 'TrackingStatus', 'IsReadOnly'],
      }).toPromise().then((tagResponse) => {
        if (tagResponse && tagResponse.value) {
          if (tagResponse.value.length > 0) {
            return tagResponse.value;
          }
          return [];
        }

        return [];
      });
  } else if (cid) {
    return edmCampaign
      .Customers.$withKey(cid)
      .Tags
      .get({
        top: 200,
        select: ['Id', 'Name', 'TrackingStatus', 'IsReadOnly'],
      }).toPromise().then((tagResponse) => {
        if (tagResponse && tagResponse.value) {
          if (tagResponse.value.length > 0) {
            return tagResponse.value;
          }
          return [];
        }

        return [];
      });
  }
  return new Promise((resolve) => {
    resolve(mockedTags.value);
  });
};
